import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from "rxjs/operators";
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';

import { environment } from "src/environments/environment";

import { EulaModalComponent } from "src/app/fvms/auth/eula/eula.modal.component";
import { PrivacyModalComponent } from "src/app/fvms/auth/privacy/privacy.modal.component";
import { AuthResetPasswordModalComponent } from "src/app/fvms/auth/reset.pw/auth.reset.pw.modal.component";

import { FvmsApiAuthService } from "src/app/shared/service/fvms.api.auth.service";
import { FvmsApiNoticeService } from "src/app/shared/service/fvms.api.notice.service";
import { NoticeDetailPopupComponent } from "src/app/fvms/notice/detail.popup/notice.detail.popup.component";
import { NoticeListPopupComponent } from "src/app/fvms/notice/list.popup/notice.list.popup.component";
import { FilterDateTime } from "src/app/shared/filter";
import { PagingInfo } from "src/app/shared/vo/fvms.paging.info";
import { FvmsNoticeInfo } from "src/app/shared/vo/fvms.notice.info";

@Component({
  templateUrl: './auth.login.component.html'
  ,styleUrls: ["./auth.login.component.scss"]
  ,providers: [DatePipe,FilterDateTime]
})
export class AuthLoginComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    formGroup: FormGroup;
    submitted:boolean = false;
    isSignInFail:boolean = false;
    signInFailMessage:string;
    listNotice:any[];
    pagingInfo:PagingInfo = new PagingInfo();
    fvmsNoticeInfo:FvmsNoticeInfo = new FvmsNoticeInfo();
    public envName:string = environment.name.toUpperCase();

    constructor(
        private modalService: NgbModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private router: Router
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private activatedRoute: ActivatedRoute
    ) {

    }

    ngOnInit() {
        this.fvmsNoticeInfo.noticeTarget = "ALL";
        this.formGroup = this.formBuilder.group({
            userId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userPw:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,isAutoSignIn:[
                false
                ,[
                    Validators.required
                ]
            ]
            ,ipAccessDevice:""
        });

        this.fvmsApiAuthService.getIpAccessDevice()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                //console.log("getIpAccessDevice","subscribe",response);
                if(response && response.ip){
                    this.formGroup.patchValue({
                        ipAccessDevice:response.ip
                    });
                }
            });



        this.fvmsApiNoticeService.getListNotice(this.fvmsNoticeInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                // console.log("getListNotice","subscribe",response);
                if(response.resultStatus === "ok" && response.resultValue){
                    this.listNotice = response.resultValue;
                    this.pagingInfo = response.pagingInfo;
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    get f() { return this.formGroup.controls; }

    clickEulaModal(){
        let modalRef = this.modalService.open(
            EulaModalComponent
            ,{
                centered:true
                //,size: "lg"
                ,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                ,scrollable: true
            }
        );
        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){

            }
        });
    }

    clickPrivacyModal(){
        let modalRef = this.modalService.open(
            PrivacyModalComponent
            ,{
                centered:true
                //,size: "lg"
                ,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                ,scrollable: true
            }
        );
        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){

            }
        });
    }

    clickResetPasswordModal(){
        let modalRef = this.modalService.open(
            AuthResetPasswordModalComponent
            ,{
                centered:true
                //,size: "lg"
                //,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                //,scrollable: true
            }
        );
        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){

            }
        });
    }

    clickNoticeListModal(){
        let modalRef = this.modalService.open(
            NoticeListPopupComponent
            ,{
                centered:true
                //,size: "lg"
                // ,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                ,scrollable: true
            }
        );
        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){

            }
        });
    }

    clickNoticeDetailModal(noticeItem){
        let modalRef = this.modalService.open(
            NoticeDetailPopupComponent
            ,{
                centered:true
                //,size: "lg"
                ,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                ,scrollable: true
            }
        );

        modalRef.componentInstance.inputNoticeItem = noticeItem;

        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){

            }
        });
        noticeItem.viewCnt++;
    }

    onSubmit(){
        this.submitted = true;
        this.isSignInFail = false;
        // console.log("onSubmit",this.formGroup.value);
        if (this.formGroup.invalid) {
            return;
        }

        this.fvmsApiAuthService.loginCheck(
                this.f.userId.value
                ,this.f.userPw.value
                ,this.f.ipAccessDevice.value
                ,"1"
            ).pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    apiResponse.resultValue.ipAccessDevice = this.f.ipAccessDevice.value;
                    this.fvmsApiAuthService.setSessionUserInfo(apiResponse.resultValue,this.f.isAutoSignIn.value);
                    let returnUrl = this.activatedRoute.snapshot.queryParamMap.get("returnUrl");

                    if(returnUrl){
                        let arrReturnUrl = returnUrl.split("?");
                        let urlPath = arrReturnUrl[0];
                        let arrUrlParam = [];
                        if(arrReturnUrl.length > 1){
                            let paramFull = arrReturnUrl[1];
                            arrUrlParam = paramFull.split("&");
                        }

                        let tmpParam = {
                            runtime:new Date().getTime()
                            ,sideBarType:"menu"
                            ,menuId:3
                        };
                        if(arrUrlParam){
                            for(let a=0;a<arrUrlParam.length;a++){
                                let item = arrUrlParam[a];
                                let arrItem = item.split("=");
                                let name = arrItem[0];
                                let val = arrItem[1];
                                tmpParam[name] = val;
                            }
                        }

                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                            ,fragment:"anchor"
                        };
                        this.router.navigate([urlPath],navigationExtras);
                    }else{
                        let tmpParam = {
                            runtime:new Date().getTime()
                            ,sideBarType:"carList"
                            ,menuId:1
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                            ,fragment:"anchor"
                        };
                        if( this.f.userId.value == "admin" )
                          this.router.navigate(["dtg/analytics/dashboard"],navigationExtras);
                        else
                          this.router.navigate(["/dtg/car/current/list"],navigationExtras);
                    }
                }else{
                    this.isSignInFail = true;
                    this.signInFailMessage=apiResponse.resultMessage;
                }
            });
    }
}
